<template>
  <b-dropdown
    variant="blue"
    size="sm"
    :disabled="isExportBusy || !url"
    class="file-export"
    right
  >
    <template #button-content>
      <span v-if="!isExportBusy">Export</span>
      <b-spinner v-else small />
    </template>
    <b-dropdown-item @click="exportAs('xlsx')">Export as Excel</b-dropdown-item>
    <b-dropdown-item @click="exportAs('csv')">Export as CSV</b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

type ExportFormat = 'xlsx' | 'csv'

const MIME: Record<ExportFormat, string> = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

/**
 * The standard report Export dropdown, for endpoints that build the file server-side
 * (`?file_format=csv|xlsx`). Give it the export `url` (null while there is nothing to
 * export) and the download `filename` without extension; it does the rest.
 */
@Component
export default class FileExportDropdown extends Vue {
  @Prop({ type: String, default: null }) url!: string | null
  @Prop({ type: String, required: true }) filename!: string

  isExportBusy = false

  async exportAs(format: ExportFormat = 'xlsx') {
    if (!this.url) return

    this.isExportBusy = true
    try {
      // The server stamps every date in this zone, so the file reads like the screen.
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      const response = await this.axios.get(this.url, {
        responseType: 'blob',
        params: { file_format: format, tz }
      })
      const blob = new Blob([response.data], { type: MIME[format] })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${this.filename}.${format}`
      link.click()
      URL.revokeObjectURL(link.href)
    } finally {
      this.isExportBusy = false
    }
  }
}
</script>
